var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor cache-write" }, [
    _c("div", { staticClass: "wrapper" }, [
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("tables.automationblock.cacheKey"))),
          ]),
          _vm._v(" "),
          _c("TiptapEditor", {
            attrs: {
              placeholder: _vm.$t("tables.automationblock.writeKeyPlaceholder"),
              "show-attributes": true,
              "automation-mode": "",
            },
            model: {
              value: _vm.clone.key,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "key", $$v)
              },
              expression: "clone.key",
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "help-text" }, [
            _c("i", { staticClass: "material-icons" }, [_vm._v("info")]),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm.$t("tables.automationblock.writeKeyHelp"))),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("tables.automationblock.cacheValueTitle"))),
          ]),
          _vm._v(" "),
          _c("TiptapEditor", {
            attrs: {
              placeholder: _vm.$t(
                "tables.automationblock.valueToSavePlaceholder"
              ),
              "show-attributes": true,
              "automation-mode": "",
            },
            model: {
              value: _vm.clone.value,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "value", $$v)
              },
              expression: "clone.value",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("tables.automationblock.cacheTypeTitle"))),
          ]),
          _vm._v(" "),
          _c("CustomPicker", {
            attrs: {
              items: _vm.typeOptions,
              idKey: "value",
              labelKey: "label",
              placeholder: _vm.$t(
                "tables.automationblock.selectCacheTypePlaceholder"
              ),
            },
            model: {
              value: _vm.clone.type,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "type", $$v)
              },
              expression: "clone.type",
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "help-text" }, [
            _c("i", { staticClass: "material-icons" }, [_vm._v("info")]),
            _vm._v(" "),
            _vm.clone.type === "public"
              ? _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("tables.automationblock.cacheTypePublicHelp"))
                  ),
                ])
              : _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("tables.automationblock.cacheTypePrivateHelp")
                    )
                  ),
                ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("tables.automationblock.dataTypeTitle"))),
          ]),
          _vm._v(" "),
          _c("CustomPicker", {
            attrs: {
              items: _vm.dataTypeOptions,
              idKey: "value",
              labelKey: "label",
              placeholder: _vm.$t(
                "tables.automationblock.selectDataTypePlaceholder"
              ),
            },
            model: {
              value: _vm.clone.dataType,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "dataType", $$v)
              },
              expression: "clone.dataType",
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "help-text" }, [
            _c("i", { staticClass: "material-icons" }, [_vm._v("info")]),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                _vm._s(_vm.$t("tables.automationblock.dataTypeUiOnlyHelp"))
              ),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("section", [
        _c("div", { staticClass: "title" }, [
          _vm._v(
            _vm._s(_vm.$t("tables.automationblock.validityDurationTitle"))
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "expires-config" },
          [
            _c("CustomPicker", {
              attrs: {
                items: _vm.expiresModeOptions,
                idKey: "value",
                labelKey: "label",
                placeholder: _vm.$t(
                  "tables.automationblock.timeTypePlaceholder"
                ),
              },
              model: {
                value: _vm.clone.expiresAt.mode,
                callback: function ($$v) {
                  _vm.$set(_vm.clone.expiresAt, "mode", $$v)
                },
                expression: "clone.expiresAt.mode",
              },
            }),
            _vm._v(" "),
            _vm.clone.expiresAt.mode === "duration"
              ? _c(
                  "div",
                  { staticClass: "duration-config" },
                  [
                    _c("TiptapEditor", {
                      attrs: {
                        placeholder: _vm.$t(
                          "tables.automationblock.durationValuePlaceholder"
                        ),
                        "show-attributes": true,
                        "automation-mode": "",
                      },
                      model: {
                        value: _vm.clone.expiresAt.duration.value,
                        callback: function ($$v) {
                          _vm.$set(_vm.clone.expiresAt.duration, "value", $$v)
                        },
                        expression: "clone.expiresAt.duration.value",
                      },
                    }),
                    _vm._v(" "),
                    _c("CustomPicker", {
                      attrs: {
                        items: _vm.durationUnitOptions,
                        idKey: "value",
                        labelKey: "label",
                        placeholder: _vm.$t(
                          "tables.automationblock.unitPlaceholder"
                        ),
                      },
                      model: {
                        value: _vm.clone.expiresAt.duration.unit,
                        callback: function ($$v) {
                          _vm.$set(_vm.clone.expiresAt.duration, "unit", $$v)
                        },
                        expression: "clone.expiresAt.duration.unit",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.clone.expiresAt.mode === "timestamp"
              ? _c(
                  "div",
                  { staticClass: "timestamp-config" },
                  [
                    _c("TiptapEditor", {
                      attrs: {
                        placeholder: _vm.$t(
                          "tables.automationblock.isoDatePlaceholder"
                        ),
                        "show-attributes": true,
                        "automation-mode": "",
                      },
                      model: {
                        value: _vm.clone.expiresAt.timestamp.value,
                        callback: function ($$v) {
                          _vm.$set(_vm.clone.expiresAt.timestamp, "value", $$v)
                        },
                        expression: "clone.expiresAt.timestamp.value",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }